<template>
  <div>
    <div id="home2" :style="'height:'+innerHeight+'px;'">
      <img style="width: 72px;margin:20px 0;" src="../assets/imgs/success.png" />
      <h1>신청 완료!<br/>지금 바로 카카오톡을 확인하세요</h1>
      <div class="moneyDiv">
        <img style="width: 64px;" src="../assets/imgs/money.png"/>
        <span style="margin:6px 0;">{{name}}님의 예상 퇴직금은</span>
        <h2>{{formatNumber(money)}}원</h2>
      </div>
      <div class="info">
        <div class="item">
          <span></span>
          <p>{{name}}님, 퇴직금 수령에 꼭 필요한 <b>계약서 링크</b>를 <b>카카오 알림톡</b>으로 방금 발송했습니다.</p>
        </div>
        <div class="item">
          <span></span>
          <p>지금 서명하셔야 담당 노무사의 <b>신청 절차</b>가 즉시 시작됩니다.</p>
        </div>

      </div>
      <div class="bottom">
        <div class="item">
          <img src="../assets/imgs/clock.png"/>
          1초 만에 신청
        </div>
        <div class="item">
          <img src="../assets/imgs/money_y.png"/>
          퇴직금 수령시에만 수수료 발생
        </div>
        <div class="btn" @click="goHome">확인</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { postAction } from '@/network/manage';
  export default {
    name: 'PhoneResult',
    components: {

    },
    data() {
      return {
        money:0,
        innerHeight:0,
        name: ""
      }
    },
    created(){
      this.innerHeight = window.innerHeight
      if(Vue.ls.get('money')){
        this.money = Vue.ls.get('money')
        this.name = Vue.ls.get('name')
        Vue.ls.remove('name')
        Vue.ls.remove('money')
      }else{
        this.$router.push('/home')
      }
    },
    methods:{
      formatNumber(value) {
        return value.toString().replaceAll(',','').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      goHome(){
        this.$router.push('/')
      },
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home2{display: flex;flex-direction: column;width: 100%;padding:20px;align-items: center;text-align: center;overflow-y: auto !important;position: absolute;}
  h1{color:#333333;font-size: 24px;}
  .moneyDiv{background-color: #EDF1FF;font-size:18px;border-radius: 20px;width: 100%;margin:40px 0;padding:20px 0;display: flex;flex-direction: column;align-items: center;}
  .moneyDiv h2{font-size: 26px;color: #3F6DFF;}
  .info{color: #717B85;display: grid;grid-template-columns: 1fr;gap: 10px;}
  .info .item{display: flex;text-align: left;}
  .info .item span{width: 4px;height: 4px;background-color: #717B85;border-radius: 50%;flex-shrink: 0;margin-right: 10px;margin-top:10px;}
  .bottom{width: calc(100vw - 40px);background-color: #ffffff;}
  .bottom .item{width: 100%;display: flex;align-items: center;font-size: 16px;color: #717B85;}
  .bottom .item img{width: 24px;height: 24px;margin-right: 10px;}
  .bottom .item:first-child{margin-bottom: 10px;}
  .btn{background:#4873FF;color:#ffffff;display: flex;justify-content: center;margin-top:20px;align-items: center;height: 52px;border-radius: 26px;font-weight: bold;}
  .btn img{width: 16px;margin-right: 10px;}
</style>
